"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDataDogContext = updateDataDogContext;
exports.beforeSend = beforeSend;
exports.useDatadog = useDatadog;
exports.dataDogContext = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _browserRum = require("@datadog/browser-rum");

var _env = _interopRequireWildcard(require("../env.config"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var dataDogContext = {
  current: {
    applicationRef: '',
    applicationId: ''
  }
};
exports.dataDogContext = dataDogContext;

function updateDataDogContext(data) {
  dataDogContext.current = _objectSpread(_objectSpread({}, dataDogContext.current), data);
}

function beforeSend(event) {
  // eslint-disable-next-line no-param-reassign
  event.context = _objectSpread(_objectSpread({}, event.context), dataDogContext.current);
}

function useDatadog() {
  (0, _react.useEffect)(function () {
    _browserRum.datadogRum.init({
      applicationId: (0, _env.default)('REACT_APP_DATADOG_APPLICATION_ID'),
      clientToken: (0, _env.default)('REACT_APP_DATADOG_CLIENT_TOKEN'),
      env: (0, _env.environment)(),
      version: (0, _env.default)('REACT_APP_VERSION'),
      service: (0, _env.default)('REACT_APP_SERVICE'),
      beforeSend: beforeSend
    });
  }, []);
}